import React from 'react';
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Grid,
  Typography,
} from '@mui/material';
import SmartToyOutlinedIcon from '@mui/icons-material/SmartToyOutlined';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import strings from '../../../localization';
import styles from './styles';

interface ICompletionMethodChoice {
  onChooseAi: () => void;
  onChooseManual: () => void;
}

const CompletionMethodChoice = ({
  onChooseAi,
  onChooseManual,
}: ICompletionMethodChoice) => {
  const options = [
    {
      key: 'ai',
      icon: <SmartToyOutlinedIcon sx={styles.optionIcon} />,
      title: strings.continueWithVoiceRegistration,
      buttonLabel: strings.continueWithAi,
      onClick: onChooseAi,
      recommended: true,
    },
    {
      key: 'manual',
      icon: <EditNoteOutlinedIcon sx={styles.optionIcon} />,
      title: strings.continueWithManualTextRegistration,
      buttonLabel: strings.fillFormManually,
      onClick: onChooseManual,
      recommended: false,
    },
  ];

  return (
    <Box sx={styles.container}>
      <Typography component="h2" sx={styles.title}>
        {strings.howWouldYouLikeToContinue}
      </Typography>
      <Typography sx={styles.subtitle}>
        {strings.chooseProfileCompletionMethod}
      </Typography>

      <Grid
        container
        columnSpacing={{ xs: 0, sm: 2, md: 3 }}
        rowSpacing={{ xs: 2, md: 3 }}
      >
        {options.map((option) =>
          (
            <Grid item xs={12} md={6} key={option.key}>
              <Card
                variant="outlined"
                sx={[
                  styles.optionCard,
                  option.recommended ? styles.recommendedCard : {},
                ]}
              >
                <CardActionArea
                  aria-label={option.buttonLabel}
                  onClick={option.onClick}
                  sx={styles.optionAction}
                >
                  <CardContent sx={styles.optionContent}>
                    <Box sx={styles.optionHeader}>
                      <Box sx={styles.iconContainer}>{option.icon}</Box>

                    </Box>
                    <Typography component="h3" sx={styles.optionTitle}>
                      {option.title}
                    </Typography>
                    <Box
                      sx={[
                        styles.optionButton,
                        option.recommended
                          ? styles.recommendedButton
                          : styles.manualButton,
                      ]}
                    >
                      <Typography component="span" sx={styles.optionButtonText}>
                        {option.buttonLabel}
                      </Typography>
                      <ArrowForwardRoundedIcon fontSize="small" />
                    </Box>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
      </Grid>
    </Box>
  );
};

export default CompletionMethodChoice;
